import {
  customInstanceWithHeader,
  type ResponseWithHeaders,
} from '@fukuri-admins/apis/client/base/axiosInstance';
import {
  getGetApiV1ThreeLetterCodePartnerAdminsNotificationsKey,
  getGetApiV1ThreeLetterCodePartnerAdminsNotificationsUrl,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type {
  GetApiV1ThreeLetterCodePartnerAdminsNotifications200,
  GetApiV1ThreeLetterCodePartnerAdminsNotificationsParams,
} from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

const fetcher = (
  threeLetterCode: string,
  apiParams: GetApiV1ThreeLetterCodePartnerAdminsNotificationsParams
) =>
  customInstanceWithHeader<GetApiV1ThreeLetterCodePartnerAdminsNotifications200>(
    getGetApiV1ThreeLetterCodePartnerAdminsNotificationsUrl(threeLetterCode, apiParams),
    { method: 'GET' }
  );

type Args = {
  threeLetterCode: string;
  page?: string;
};

type IUseGetPartnerAdminsNotifications = (args: Args) => {
  data: GetApiV1ThreeLetterCodePartnerAdminsNotifications200;
  totalPage: number;
  totalCount: number;
};

/**
 * プッシュ通知一覧取得フック
 */
export const useGetPartnerAdminsNotifications: IUseGetPartnerAdminsNotifications = ({
  threeLetterCode,
  page,
}) => {
  const apiParams: GetApiV1ThreeLetterCodePartnerAdminsNotificationsParams = {
    ...(page && !Number.isNaN(Number(page)) && { page: Number(page) }),
  };

  const { data } = useFetch<
    ResponseWithHeaders<GetApiV1ThreeLetterCodePartnerAdminsNotifications200>
  >(
    getGetApiV1ThreeLetterCodePartnerAdminsNotificationsKey(threeLetterCode, apiParams),
    () => fetcher(threeLetterCode, apiParams),
    { suspense: true }
  );

  const totalPage = Number(data.headers['total-pages']) || 0;
  const totalCount = Number(data.headers['total-count']) || 0;

  return {
    data: data.data,
    totalPage,
    totalCount,
  };
};
